import { IStringConstraintPattern } from '../base/annotation';
import { shellStringResources } from '../../Resources/ShellStringResources';

export const defaultTimeout: string = '0.12:00:00';

export const defaultPolicy = Object.freeze({
    retry: 0,
    timeout: defaultTimeout,
    retryIntervalInSeconds: 30,
    secureOutput: false,
    secureInput: false
});

export const timeoutValidationPatterns = [
    {
        // validate day: 0 - 7. format: __(H)H:(M)M:(S)S, may have unlimited leading 0s
        message: shellStringResources.Validator_ExceedDayLimit, // more than 7 days
        regex: /^((0*[0-6]\.)?.?.(:.?.){2})$|^(0*7\.0?0:0?0:0?0)$/
    },
    {
        // validate hour: 0 - 23. format: (D.)__:(M)M:(S)S
        message: shellStringResources.Validator_HourRange,
        regex: /^(\d+\.)?((0?\d)|(1\d)|(2[0-3]))(:.?.){2}$/
    },
    {
        // validate minute/second: 0 - 59. format: (D.)(H)H:____
        message: shellStringResources.Validator_MinSecRange,
        regex: /^(\d+\.)?.?.(:[0-5]?\d){2}$/
    }
] as IStringConstraintPattern[];